module.exports = __webpack_public_path__ + "img/man.923d90fe.png";